import React from 'react';

import {createStackNavigator} from '@react-navigation/stack';

import UserIcon from 'src/HeaderComponents/UserIcon';
import FoxShopIcon from 'src/HeaderComponents/FoxShopIcon';
import {MainIcon} from 'src/HeaderComponents/HeaderComponents';

import {PageTitle} from 'src/HeaderComponents/HeaderComponents';

import {SafeAreaView} from 'react-native-safe-area-context';
import {navigationRef} from './navigationHelpers';

const Stack = createStackNavigator();

export default function SimpleStackNavigator({
  headerText,
  component,
  name,
  route,
  coinsTestID = 'coins',
}) {
  return (
    <SafeAreaView style={{flex: 1, backgroundColor: 'white'}}>
      <Stack.Navigator
        screenOptions={() => ({
          title: 'Home',
          headerHideShadow: true,
          gestureEnabled: false,
          headerTitleAlign: 'center',
          cardStyle: {
            flex: 1,
            paddingTop: 0,
          },
          headerStyle: {
            elevation: 0,
            shadowOpacity: 0,
            boxShadow: '',
            shadowColor: 'transparent',
          },
          headerLeft: () => <UserIcon />,
          headerTitle: () =>
            headerText ? (
              <PageTitle text={headerText} />
            ) : (
              <MainIcon
                handlePress={() => {
                  navigationRef.navigate(
                    'LandingPageMain',
                    'SimpleStackNavigator',
                  );
                }}
              />
            ),
          headerRight: () => <FoxShopIcon coinsTestID={coinsTestID} />,
        })}>
        <Stack.Screen
          name={name}
          options={{title: 'home!'}}
          component={component}
          initialParams={route?.params || {}}
        />
      </Stack.Navigator>
    </SafeAreaView>
  );
}
